import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import TextBox from "../common/TextBox";
import Button from "../common/Button";
import OnboardContext from "./context";
import { langComponent } from "../../constants";
import AppContext from "../../AppContext";
import { CreateInput } from "thai-address-autocomplete-react";

const InputThaiAddress = CreateInput();

import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowLeftSvg } from "../../assets/icons/arrow-left.svg";
import _ from "lodash";

const Address = () => {
  const { goBack, goForward, information, addInformation } =
    useContext(OnboardContext);
  const { getLang } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);
  const TranslationProfile = getLang(langComponent.profile);
  const [address] = useState(
    !_.isEmpty(information.address)
      ? information.address
      : {
          streetAddress: "",
          apt: "",
          subDistrict: "",
          district: "",
          province: "",
          postalCode: "",
        }
  );
  const [addr, setAddr] = useState(
    !_.isEmpty(information.address)
      ? {
          district: information.address.subDistrict, // ตำบล tambol
          amphoe: information.address.district, // อำเภอ amphoe
          province: information.address.province, // จังหวัด changwat
          zipcode: information.address.postalCode, // รหัสไปรษณีย์ postal code
        }
      : {
          district: "",
          amphoe: "",
          province: "",
          zipcode: "",
        }
  );
  const formikRef = useRef(null);

  useEffect(() => {
    if (!formikRef.current) return;

    if (!addr.amphoe && !addr.district && !addr.province && !addr.zipcode) {
      formikRef.current.setFieldError("location", "");
      return;
    }

    if (!addr.amphoe || !addr.district || !addr.province || !addr.zipcode) {
      formikRef.current.setFieldError(
        "location",
        "Please specify all locations"
      );
      return;
    }

    formikRef.current.setFieldError("location", "");
  }, [addr]);

  const handleValidate = ({ streetAddress }) => {
    let errors = {};

    if (!streetAddress) errors.streetAddress = TranslationCommon("Required");

    if (!addr.amphoe || !addr.district || !addr.province || !addr.zipcode) {
      errors.location = "Please specify all locations";
    }

    return errors;
  };

  const handleSubmit = (values) => {
    addInformation({
      address: {
        streetAddress: values.streetAddress,
        apt: values.apt,
        subDistrict: addr.district,
        district: addr.amphoe,
        province: addr.province,
        postalCode: addr.zipcode,
      },
    });
    goForward();
  };

  const handleChange = (scope) => (value) => {
    setAddr((oldAddr) => ({
      ...oldAddr,
      [scope]: value,
    }));
  };

  const handleSelect = (address) => {
    setAddr(address);
  };

  return (
    <div>
      <h1 className="onboard__header">{TranslationProfile("Address")}</h1>
      <Formik
        initialValues={address}
        validate={handleValidate}
        onSubmit={handleSubmit}
        innerRef={formikRef}
      >
        {({ errors }) => {
          return (
            <Form className="onboard__form onboard__form-address">
              <div className="onboard__form-content">
                <div className="onboard__form-item">
                  <TextBox
                    name="streetAddress"
                    placeholder={TranslationProfile("Street Address")}
                    label="Street Address"
                  />
                </div>
                <div className="onboard__form-item">
                  <TextBox
                    name="apt"
                    placeholder={TranslationProfile("Apt, suite, etc")}
                    label="Apt, suite, etc"
                  />
                </div>
                <div className="onboard__form-item">
                  <div className="onboard__form-address__location">
                    <div className="address-textbox">
                      <label className="address-textbox__title">
                        {TranslationProfile("Sub District (Thai)")}
                      </label>
                      <InputThaiAddress.District
                        value={addr["district"]}
                        onChange={handleChange("district")}
                        onSelect={handleSelect}
                        className="address-textbox__input"
                      />
                    </div>
                    <div className="address-textbox">
                      <label className="address-textbox__title">
                        {TranslationProfile("District (Thai)")}
                      </label>
                      <InputThaiAddress.Amphoe
                        value={addr["amphoe"]}
                        onChange={handleChange("amphoe")}
                        onSelect={handleSelect}
                        className="address-textbox__input"
                      />
                    </div>
                    <div className="address-textbox">
                      <label className="address-textbox__title">
                        {TranslationProfile("Province (Thai)")}
                      </label>
                      <InputThaiAddress.Province
                        value={addr["province"]}
                        onChange={handleChange("province")}
                        onSelect={handleSelect}
                        className="address-textbox__input"
                      />
                    </div>
                    <div className="address-textbox">
                      <label className="address-textbox__title">
                        {TranslationProfile("Postal Code")}
                      </label>
                      <InputThaiAddress.Zipcode
                        value={addr["zipcode"]}
                        onChange={handleChange("zipcode")}
                        onSelect={handleSelect}
                        className="address-textbox__input"
                      />
                    </div>
                  </div>
                  {errors.location && (
                    <span
                      className="address-textbox__error"
                      style={{ columnSpan: 2 }}
                    >
                      {errors.location}
                    </span>
                  )}
                </div>
              </div>
              <div className="onboard__form-cta">
                <Button
                  label={TranslationCommon("Return")}
                  leadingIcon={<ArrowLeftSvg />}
                  onClick={goBack}
                  variant="secondary"
                />
                <div className="onboard__form-cta__divider" />
                <Button
                  type="submit"
                  label={TranslationCommon("Continue")}
                  trailingIcon={<ArrowRightSvg />}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

Address.propTypes = {};

export default Address;
